import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const avatarModalSlice = createSlice({
  name: 'avatarModal',
  initialState: { status: false },
  reducers: {
    setAvatarModalStatus: (state, action: PayloadAction<boolean>) => {
      state.status = action.payload;
    },
  },
});

export const { setAvatarModalStatus } = avatarModalSlice.actions;
export default avatarModalSlice.reducer;
